import { render, staticRenderFns } from "./ImgView.vue?vue&type=template&id=dcdf6b04&scoped=true&"
import script from "./ImgView.vue?vue&type=script&lang=js&"
export * from "./ImgView.vue?vue&type=script&lang=js&"
import style0 from "./ImgView.vue?vue&type=style&index=0&id=dcdf6b04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf6b04",
  null
  
)

export default component.exports